// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn[data-v-25c705bd]:hover{cursor:pointer}.untransformText[data-v-25c705bd]{text-transform:none}", ""]);
// Exports
module.exports = exports;
